import * as R from 'ramda';

import WorkOrderStatusPill from '@atom/components/common/workOrderDetail/workOrderStatusPill/WorkOrderStatusPill';
import { useNavigation } from '@atom/hooks/useNavigation';
import { WorkOrder } from '@atom/types/work';
import timeUtilities from '@atom/utilities/timeUtilities';
import userUtilities from '@atom/utilities/userUtilities';

import classes from './sidebars.module.css';

export type WorkRowProps = { work: WorkOrder };

const WorkRow = ({ work }: WorkRowProps) => {
  const [, { navigate }] = useNavigation();

  const assigneeCount = userUtilities.rollUpTaskUsers(work.tasks as any).length;
  const taskCount = R.isEmpty(work.tasks) ? 0 : work.tasks.length;

  return (
    <div
      className={classes.workRow}
      onClick={() => navigate(`/workOrders/${work.id}`)}
    >
      <div className={classes.workRowContent}>
        <div className={classes.workRowName}>{work.name}</div>
        <WorkOrderStatusPill
          statusId={work.statusId}
          className="dashboard-map-list"
        />
        <div className={classes.workRowMeta}>
          <span className={classes.workRowMetaItem}>
            {`Due Date: ${timeUtilities.setDisplayDate(work.dueDate)}`}
          </span>
          <span
            className={classes.workRowMetaItem}
          >{`Team: ${assigneeCount}`}</span>
          <span
            className={classes.workRowMetaItem}
          >{`Tasks: ${taskCount}`}</span>
        </div>
      </div>
    </div>
  );
};

export default WorkRow;
